import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
export interface IMultipleField {
  label: string,
  value: string,
  selected: boolean
}
/**
 * 複数選択フィールド
 *【ラベル内容:componentLabel:string】
 *【選択候補:selectItems:{label: string, value: any, selected: boolean}[]】
 *【選択オプション:displayedItems:string[]】
 *【表示数:showNum:number】
 *【表示条件:visible:boolean】
 *【非活性:disabled:boolean】
 *【全選択時は空にする:getsEmptyWhenAllSelected:boolean = false】
 *【必須項目:required:boolean = false】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-multiple-selector-field',
  templateUrl: './multiple-selector-field.html',
  styles: [`
    
  `]
})
export class MultipleSelectorField extends BaseWidget {
  /**
   * 選択オプションの表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 選択オプションに対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * ラベル内容
   */
  @Input() componentLabel:string

  /**
   * 選択候補
   */
  @Input() selectItems:{label: string, value: any, selected: boolean}[]

  /**
   * 選択オプション
   */
  @Input() displayedItems:string[]

  /**
   * 表示数
   */
  @Input() showNum:number

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * 全選択時は空にする
   */
  @Input() getsEmptyWhenAllSelected:boolean = false

  /**
   * 必須項目
   */
  @Input() required:boolean = false

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  private allClicked: boolean = false;
  doUpData(event,clickEvent: string):void{
    let itemsBefore = this.displayedItems
    this.displayedItems = [];
    this.allClicked = false;
    // 選択項目を変更した場合
    if("selectItemChange" === clickEvent && event){
      for(let item of event){
        if(item.selected){
          this.displayedItems.push(item.value);
        }
      }
    }
    // ALLボタンを押した場合（全選択時は空にしない）
    if("doSelectAll" === clickEvent) {
      for(let item of this.selectItems){
        this.displayedItems.push(item.value);
      }
    }
    if ((this.required || this.getsEmptyWhenAllSelected) && this.displayedItems.length === 0) {
      this.displayedItems = this.selectItems.map(item => item.value);
    }
    if (this.getsEmptyWhenAllSelected && this.selectItems.every(item => this.displayedItems.indexOf(item.value) !== -1)) {
      this.allClicked = true;
    }
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => this.getsEmptyWhenAllSelected && this.allClicked ? [] : this.displayedItems,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    if (itemsBefore.length !== this.displayedItems.length
      || itemsBefore.some(item => this.displayedItems.indexOf(item) === -1)) {
      this.on("change")
    }
  }
  get multipleFieldList() {
    let target: IMultipleField[] = [];
    if (!!this.selectItems && this.selectItems.length !== 0) {
      if (this.getsEmptyWhenAllSelected && this.allClicked && this.displayedItems.length === 0) {
        this.displayedItems = this.selectItems.map(item => item.value);
        this.allClicked = false;
      }
      this.selectItems.forEach((each) => {
        if (!!this.displayedItems && this.displayedItems.length > 0
            && this.displayedItems.indexOf(each.value) !== -1) {
          each.selected = true;
          target.push(each);
        } else {
          each.selected = false;
          target.push(each);
        }
      });
    }
    return target;
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/multiple-selector-field/multiple-selector-field.component.ts